import { httpClient } from '@/network/clientController'

/** Submit token challenge
*/
export const submitChallenge = payload => {
	return httpClient({
		method: 'POST',
		url: '/challenge',
		data: payload
	})
}

/** Request new token challenge
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_retrieveCredentialschallengereSend
*/
export const requestNewChallenge = payload => {
	return httpClient({
		method: 'POST',
		url: '/challenge/reSend',
		data: payload
	})
}
